module.exports = __webpack_public_path__ + "img/map9.39dd06f5.png";